import { Tooltip, TooltipProps } from "antd";
import { getOperation, useOperation } from "../../../../../../../../contexts/OperationContext";
import Loading from "../../../../Loading";
import styles from "../../style.module.scss";

export default function LoadingOperation() {
    const [modeDrag] = useOperation(state => state.modeDrag);
    const [loading] = useOperation(state => Boolean(state.loadingKeys[state.currentKey]));
    const [message] = useOperation(state => state.data?.message);
    const get = getOperation();
    const id = get().data?.operation.id || ""
    const viewLoading = <div className={styles.topLayer} data-operation-id={id}>
        <Loading id={id + '-loading'} loading={loading} />
    </div>

    if (modeDrag === 'move')
        return viewLoading;

    const propsTooltip: TooltipProps = {
        title: message,
    }

    if (modeDrag.length > 0)
        propsTooltip.open = false;

    return <Tooltip {...propsTooltip}>{viewLoading}</Tooltip>
};
